import gql from 'graphql-tag'

export const MAP_STRING_INT_MODEL_FRAGMENT = gql`
  fragment MapStringIntModelFields on MapStringInt {
    items {
      key
      value
    }
  }
`
